"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _ = require("./..");
var _AddMediaActionButton = _interopRequireDefault(require("../AddMediaActionButton/AddMediaActionButton.js"));
var _TemplateChooser = require("./TemplateChooser.styled");
var _TemplateItem = _interopRequireDefault(require("./TemplateItem"));
var _utils = require("../../utils");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TemplateChooser = function TemplateChooser(_ref) {
  var _useState3;
  var mediaSources = _ref.mediaSources,
    isLoading = _ref.isLoading,
    templates = _ref.templates,
    onCancel = _ref.onCancel,
    onSelectTemplate = _ref.onSelectTemplate,
    isEventTemplate = _ref.isEventTemplate;
  var _useState = (0, _react.useState)((_useState3 = {}, (0, _defineProperty2["default"])(_useState3, _constants.TEMPLATE, ''), (0, _defineProperty2["default"])(_useState3, _constants.EVENT, ''), _useState3)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedTemplate = _useState2[0],
    setSelectedTemplate = _useState2[1];
  var selectedTab = isEventTemplate ? _constants.EVENT : _constants.TEMPLATE;
  var templateName = selectedTemplate && selectedTemplate[selectedTab] || null;
  var _useState4 = (0, _react.useState)(null),
    _useState5 = (0, _slicedToArray2["default"])(_useState4, 2),
    mediaOptionSelected = _useState5[0],
    setMediaOptionSelected = _useState5[1];
  var onMediaActionSelected = function onMediaActionSelected(value) {
    setMediaOptionSelected(value);
  };
  var handleAdd = function handleAdd(e) {
    e.preventDefault();
    // using template name. get the object and send object
    var selectedTemplate = templates.find(function (template) {
      return (
        // key does not exists in the template when the file is uploaded specifically via UVS, hence using template._id for such templates and template.name for stock content templates
        template.key === templateName || template._id === templateName || template.name === templateName
      );
    });
    onSelectTemplate(_objectSpread(_objectSpread({}, selectedTemplate), {}, {
      isEventTemplate: isEventTemplate,
      media: mediaOptionSelected
    }));
  };
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setSelectedTemplate(_objectSpread(_objectSpread({}, selectedTemplate), {}, (0, _defineProperty2["default"])({}, selectedTab, value)));
  };
  var isAddButtonDisabled = !templateName;
  if (isLoading) {
    return _react["default"].createElement("div", null, "Loading templates...");
  }
  if (!templates || !templates.length) {
    return _react["default"].createElement("div", null, _react["default"].createElement("div", {
      className: "text-center"
    }, "No templates available."), _react["default"].createElement(_TemplateChooser.StyledJustifyRight, null, _react["default"].createElement(_TemplateChooser.StyledCloseButton, {
      "data-testid": "closeButton",
      color: "light",
      variant: "outlined",
      onClick: function onClick(e) {
        e.preventDefault();
        onCancel();
      }
    }, "Close")));
  }
  var acceptedTemplates = templates.filter(function (_ref2) {
    var key = _ref2.key,
      name = _ref2.name;
    var fileType = (0, _utils.getFileSourceType)(name || key);
    return [_constants.IMAGE_FILE, _constants.VIDEO_FILE, _constants.AUDIO_FILE].includes(fileType);
  });
  var wrapperId = 'template-chooser-container';
  var containerElementSelector = "#".concat(wrapperId);
  return _react["default"].createElement(_reactstrap.Form, {
    "data-testid": "templateChooserForm",
    onSubmit: handleAdd
  }, _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement(_TemplateChooser.StyledWrapper, {
    id: wrapperId
  }, acceptedTemplates.map(function (item, idx) {
    var title = item.name ? item.name : item.key.replace(/.*\//, '');
    return _react["default"].createElement(_TemplateItem["default"], {
      title: title,
      handleChange: handleChange,
      index: idx,
      item: item,
      key: idx,
      containerElementSelector: containerElementSelector,
      isSelected: templateName === item.key || templateName === item._id || templateName === item.name
    });
  }))), _react["default"].createElement(_reactstrap.FormGroup, null, _react["default"].createElement("div", {
    className: "float-end"
  }, mediaSources ? _react["default"].createElement(_AddMediaActionButton["default"], {
    onMediaActionSelected: onMediaActionSelected,
    mediaSources: mediaSources,
    disabled: isAddButtonDisabled
  }) : _react["default"].createElement(_.Button, {
    "data-testid": "chooseTemplate",
    disabled: isAddButtonDisabled
  }, "Save"), ' ', _react["default"].createElement(_TemplateChooser.StyledCloseButton, {
    "data-testid": "closeButton",
    color: "light",
    variant: "outlined",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Close"))));
};
TemplateChooser.propTypes = {
  mediaSources: _propTypes["default"].array,
  isLoading: _propTypes["default"].bool.isRequired,
  templates: _propTypes["default"].array.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  onSelectTemplate: _propTypes["default"].func.isRequired,
  isEventTemplate: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = TemplateChooser;